export default "__VITE_ASSET__B6K56TTj__"